import React from 'react';

export default class FooterPublic extends React.Component{
    render(){
        return (
            <div>
               Footer Private Page Component
            </div>
        );
    }
}